import { ILearningPath } from 'models/learningPath.model'
import api from 'api'

const getLearningPath = ({ id }): Promise<ILearningPath> => {
  return api.get<ILearningPath>(`/learning_paths/${id}`).then(({ data }) => {
    return data
  })
}

export default getLearningPath
